import React, { useEffect } from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router";
import swal from "sweetalert";
import { IconArrowBack } from "@tabler/icons";
import UserService from "src/service/userService";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: " Change User Password ",
  },
];

const validationSchema = yup.object({
  password: yup
    .string("Enter new password")
    .min(8, "new password should be of 8 digit length")
    .max(8, "new password should be of 8 digit length")
    .required("new password is Required"),
});

const ChangeUserPassword = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  // get drivers list

  const param = useParams();

  const initialValues = {
    id: param.id,
    password: "",
    d_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values, { setSubmitting }) => {
        if (values.password !== values.confirm_password) {
          swal("error", "Passwords do not match", "error");
          return;
        }

        try {
          const res = await UserService.changeUserPassword({
            id: values.id,
            password: values.password,
            d_by: values.d_by,
          });

          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/userlist");
          }, 1000);
        } catch (error) {
          swal("error", error.message, "error");
        } finally {
          setSubmitting(false);
        }
      },
    });

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  return (
    <div>
      <Breadcrumb title="Change Password" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Change Password
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate(-1);
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            {/*   ==== assign driver name  -===  */}

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="password">
                New Password <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="password"
                name="password"
                type="password"
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.password && Boolean(errors.password)}
                helperText={touched.password && errors.password}
                variant="outlined"
                placeholder="Enter password"
                fullWidth
              />
            </Grid>
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="confirm_password">
                Confirm Password <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="confirm_password"
                name="confirm_password"
                type="password"
                value={values.confirm_password}
                onChange={handleChange}
                onBlur={handleBlur}
                error={
                  touched.confirm_password && Boolean(errors.confirm_password)
                }
                helperText={touched.confirm_password && errors.confirm_password}
                variant="outlined"
                placeholder="Enter Confirm password"
                fullWidth
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Button color="success" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default ChangeUserPassword;
